module.exports = __webpack_public_path__ + "static/AltDinner18-1bd8867728164eeca0476715522eac9d.jpg";